import React from "react";

interface CustomClassNames {
    inputClassName?: string;
    buttonClassName?: string;
    newsletterId?: string;
}

const Newsletter: React.FC<CustomClassNames> = ({
    inputClassName,
    buttonClassName,
    newsletterId = "74485"
}) => {

    if (!inputClassName) {
        inputClassName = "w-full col-start-1 row-start-1 px-6 py-3 pl-10 rounded-xl border-2 border-brown-primary placeholder-black-subtile text-lg active:outline-none focus:outline-red-secondary focus:outline-2";
    }
    if (!buttonClassName) {
        buttonClassName = "flex items-center btn-primary justify-center transition-colors duration-300 tablet:min-w-fit hover:bg-brown-50 focus:outline-red-secondary focus:outline-2";
    }

    return (
        <>
            <form
                action={`https://lenker.nyhetsbrev.frukt.no/p/s/${newsletterId}`}
                acceptCharset="utf-8"
                method="post"
                id="newsletter"
                className="mnm-embed-form flex flex-col gap-2 tablet:flex-row tablet:justify-end"
            >
                    <div className="grid grid-cols-1 w-full">
                        <input
                            type="email"
                            name="email"
                            className={inputClassName}
                            placeholder="E-postadresse"
                            required
                            pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$"
                            onInvalid={(e) =>
                                (e.target as HTMLInputElement).setCustomValidity(
                                    "Skriv inn en gyldig e-postadresse."
                                )
                            }
                            onInput={(e) =>
                                (e.target as HTMLInputElement).setCustomValidity("")
                            }
                        />
                        <div
                            className="icon-mail pointer-events-none col-start-1 row-start-1 self-center ml-3"
                            aria-hidden="true"
                        ></div>
                    </div>
                    <button
                        type="submit"
                        className={buttonClassName}
                    >
                        Meld på
                        <div className="icon-arrow-right" aria-hidden="true"></div>
                    </button>
                </form>
        </>
    );
};

export default Newsletter;